import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { DocumentService } from 'src/app/core/services/document.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/core/services/common.service';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Signer } from '../submission/submission.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { EnumContractUserRole, EnumContractUserStatus } from '../../../../../../core/constants/contract';
import { WarningReselectSignApproverComponent } from '../warning-reselect-sign-approver/warning-reselect-sign-approver.component';

@Component({
  selector: 'app-re-signature-process-dialog',
  templateUrl: './re-signature-process-dialog.component.html',
  styleUrls: ['./re-signature-process-dialog.component.scss']
})
export class ReSignatureProcessDialogComponent implements OnInit, OnDestroy {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<ReSignatureProcessDialogComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    private commonService: CommonService,
    private digitalCertificateService: DigitalCertificateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public autoUserService: AutoUserService,
    private contractService: ContractService,
  ) {
    // Get data from ViewDocumentComponent
    this.submission.idContract = data.id;
    this.documentName = data.name;
    this.isAutoSign = data.isAutoSign;
    // this.userSign = data.userSign;
    this.contractId = data.contractId;
    dialogRef.disableClose = false;
    this.userId = localStorage.getItem('userId');
  }

  submission = {
    idContract: '',
    idSigner: ''
  };

  documentName: '';
  name: '';
  success = false;
  isAutoSign = false;
  // Columns of table
  displayedColumns: string[] = ['fullName', 'userName', 'enterprise'];
  // Data for table
  signers: Signer[];
  hasDigitalCertificateServer = false;
  // current status when signed
  isCurrentStatus = 1;
  page: number;
  pageSize: number;
  routeLink: string;
  enterprise: '';
  documentTypeSearch: '';
  nameOrCode: '';
  customerName: '';
  status: '';
  serviceType: '';
  taxCode: '';
  createdUser: '';
  createdTimeFrom: '';
  createdTimeTo: '';
  finishDateFrom: '';
  finishDateTo: '';
  sortDirection: '';
  sortColumn: '';
  goFrom: '';
  inputPartyValue: any;
  filteredPartyOptions: any;
  nzCheckLoadingParty: boolean;
  nzCheckLoadingUser: boolean;
  filteredUserOptions: any;
  initialInfo: any;
  newInitialInfo: any;
  inputUserValue: string;
  isFormChanging: boolean;
  private userId: string;
  private contractId: string;
  private userSign = [];
  idTimeout = null;
  documentCode = '';
  currentInitialText = '';

  ngOnInit() {
    // this.getSigners(this.data.id);
    this.notificationService.subscribeErrorService();
    this.getContractUserApprove();
    this.documentCode = this.data.document.code ? `${this.data.document.code} - ${this.data.document.name}` : this.data.document.name;
    this.currentInitialText = this.commonService.format(this.message.getMessage('re_submit_sign_confirmation.current_initial_info'), this.documentCode);
  }

  onChangeUserSignSearch(event): void {
    if (this.idTimeout) {
      clearTimeout(this.idTimeout);
    }

    setTimeout(
      () => {
        if (event.trim().length > 0) {
          this.nzCheckLoadingUser = true;
          this.autoUserService.fetchAutoSignatureProcess(event.trim(), this.contractId)
            .then(result => {
              let listIdApproval = (this.userSign || []).filter(item => item.role === EnumContractUserRole.APPROVE && item.status !== EnumContractUserStatus.PROCESSING);
              listIdApproval = listIdApproval.map(item => item.userId);
              this.filteredUserOptions = result.filter(item => !listIdApproval.includes(item.id) && item.id !== this.initialInfo.id);
            }).finally(() => {
              this.nzCheckLoadingUser = false;
            });
        } else {
          this.filteredUserOptions = [];
        }
      }, 250
    );
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  cancel() {
    this.dialogRef.close();
  }

  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '30%',
        data: this.message.getMessage('messages.confirm_change_data')
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }


  autocompleteUserSelected($event, user: any) {
    if ($event.isUserInput) {
      this.isFormChanging = true;
      this.newInitialInfo = user;
    }
  }

  onClickBtnConfirm() {
    const dialogRe = this.dialog.open(WarningReselectSignApproverComponent, {
      width: '40%',
      data: this.commonService.format(
        this.message.getMessage('re_submit_sign_confirmation.confirm_re_signature_process'),
        this.documentCode,
        this.initialInfo.name,
        this.initialInfo.email,
        this.initialInfo.phone,
        this.newInitialInfo.fullName,
        this.newInitialInfo.email,
        this.newInitialInfo.phone,
      )
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        const data = {
          contractId: this.data.contractId,
          userInitial: {
            ...this.initialInfo,
            userId: this.initialInfo.id
          }, // người trình ký cũ
          userApprove: {
            ...this.newInitialInfo,
            userId: this.newInitialInfo.id
          }, // người trình ký lại
          reason: rs // Lý do trình ký lại
        };
        this.contractService.addUserSignatureProcess(data).subscribe(result => {
          if (!result.success) {
            this.toastr.error(result.message);
          } else {
            this.toastr.success(this.message.getMessage('messages.re_signature_process_success'));
            this.dialogRef.close(true);
          }
        }, error => {
          this.toastr.error(this.message.getMessage('messages.re_signature_process_fail'));
        });
      }
    });

  }

  getContractUserApprove() {
    this.initialInfo = this.data.contractUserApprove[0];
  }

}
